export const emailRegularExpression = /^(?!.*\.{2})[ ]*[\w]+[\w\.]*[\w]*[\+]*[\d]*@[\w]+\.[a-zA-Z]+[ ]*/;